import React from "react";
import SmartLink from "../../shared/links/SmartLink";
import style from "../../../../src/assets/css/modules/contact-us/online-link.css";

const SmartOnlineLink = ({ pathTo, iconName, linkText, isExternalLink,isDisabled,disableStyle, id }) => {
  return (
      <SmartLink to={pathTo} className={disableStyle?style.disabled:style.onlineLink} isExternalLink={isExternalLink}
      isDisabled={isDisabled} id={id}
        >
      <i className={iconName} />
      <span>{linkText}</span>
    </SmartLink>
  );
};

export default SmartOnlineLink;
